import React from 'react';
import './App.css';
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import { Route, Routes } from 'react-router-dom';
import MyNavbar from "./components/MyNavbar";
import LandingPage from "./pages/Landing";
import PrivacyPage from "./pages/Privacy";


function App() {
    return (
            <div className="d-flex flex-column text-white">
                <MyNavbar />
                <Container>
                    <Routes>
                        <Route path={"/"} element={<LandingPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                    </Routes>
                </Container>
            </div>
    );
}

export default App;
